// // tables/SalesInvoiceTable.tsx
// import React from 'react';
// import { Card } from '@components/card/card';
// import { useTranslation } from 'react-i18next';

// interface SalesInvoiceTableProps {
//   data: any[];
//   selectedId: string | null;
//   onSelect: (id: string, code: string) => void;
//   isLoading: boolean;
//   language: string;
// }

// export const SalesInvoiceTable: React.FC<SalesInvoiceTableProps> = ({
//   data,
//   selectedId,
//   onSelect,
//   isLoading,
//   language
// }) => {
//   const { t } = useTranslation();
//   const isArabic = language === 'ar';

//   const getTotalAmount = () => {
//     return data.reduce((sum, item) => sum + (item.netAmount || item.grossAmount || 0), 0);
//   };

//   const getSelectedAmount = () => {
//     const selectedItem = data.find(item => item.id === selectedId);
//     return selectedItem ? selectedItem.netAmount || selectedItem.grossAmount || 0 : 0;
//   };

//   if (isLoading) {
//     return (
//       <div className='text-center py-5'>
//         <div className='spinner-border text-primary' role='status'>
//           <span className='visually-hidden'>{t('Loading')}</span>
//         </div>
//         <p className='text-muted mt-2'>{t('LoadingSalesInvoices')}</p>
//       </div>
//     );
//   }

//   return (
//     <Card className='mb-4'>
//       <div className='card-header d-flex justify-content-between align-items-center'>
//         <h6 className='mb-0'>
//           <i className='fas fa-file-invoice me-2'></i>
//           {t('SalesInvoicesListTitle')}
//         </h6>
//       </div>

//       <div className='card-body p-0'>
//         <div className='table-responsive'>
//           <table className='table table-hover mb-0'>
//             <thead className='table-light fw-bold'>
//               <tr>
//                 <th className='text-center small' style={{ width: '50px' }}>
//                   #
//                 </th>
//                 <th className='text-center small' style={{ width: '15%' }}>
//                   {t('OrderNumber')}
//                 </th>
//                 <th className='text-center small' style={{ width: '15%' }}>
//                   {t('OrderDate')}
//                 </th>
//                 <th className='text-center small' style={{ width: '20%' }}>
//                   {t('Customer')}
//                 </th>
//                 <th className='text-center small' style={{ width: '15%' }}>
//                   {t('Amount')}
//                 </th>
//                 <th className='text-center small' style={{ width: '20%' }}>
//                   {t('OperatingUnit')}
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {data.map(item => {
//                 const isSelected = selectedId === item.id;

//                 return (
//                   <tr
//                     key={item.id}
//                     className={isSelected ? 'table-primary' : ''}
//                     style={{ cursor: 'pointer' }}
//                     onClick={() => onSelect(item.id, item.code)}
//                   >
//                     <td className='text-center align-middle'>
//                       <div className='form-check'>
//                         <input
//                           type='radio'
//                           className='form-check-input'
//                           name='salesInvoiceSelection'
//                           checked={isSelected}
//                           onChange={() => onSelect(item.id, item.code)}
//                         />
//                       </div>
//                     </td>

//                     <td className='text-center align-middle fw-bold'>{item.code}</td>

//                     <td className='text-center align-middle'>
//                       {item.transactionDate ? item.transactionDate.split('T')[0] : '-'}
//                     </td>

//                     <td className='text-center align-middle'>
//                       {isArabic ? item.peopleName2 || item.peopleName : item.peopleName || item.peopleName2}
//                     </td>

//                     <td className='text-center align-middle'>
//                       <span className='fw-bold text-primary'>{item.netSale || 0}</span>
//                     </td>

//                     <td className='text-center align-middle'>
//                       {isArabic
//                         ? item.organizationName2 || item.organizationName
//                         : item.organizationName || item.organizationName2}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div className='card-footer d-flex justify-content-between align-items-center'>
//         <div className='text-muted small'>
//           {t('SalesInvoicesFooterSummary', {
//             count: data.length,
//             total: data.length
//           })}
//         </div>
//       </div>
//     </Card>
//   );
// };

// tables/SalesInvoiceTable.tsx
import React, { useState, useMemo, useEffect } from 'react';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';

interface SalesInvoiceTableProps {
  data: any[];
  selectedId: string | null;
  onSelect: (id: string, code: string) => void;
  isLoading: boolean;
  language: string;
}

export const SalesInvoiceTable: React.FC<SalesInvoiceTableProps> = ({
  data,
  selectedId,
  onSelect,
  isLoading,
  language
}) => {
  const { t } = useTranslation();
  const isArabic = language === 'ar';
  const [searchTerm, setSearchTerm] = useState('');

  // Reset search when data changes
  useEffect(() => {
    setSearchTerm('');
  }, [data]);

  // Filter data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm.trim()) return data;

    const term = searchTerm.toLowerCase().trim();
    return data.filter(item => {
      return (
        (item.code && item.code.toLowerCase().includes(term)) ||
        (item.peopleName && item.peopleName.toLowerCase().includes(term)) ||
        (item.peopleName2 && item.peopleName2.toLowerCase().includes(term)) ||
        (item.organizationName && item.organizationName.toLowerCase().includes(term)) ||
        (item.organizationName2 && item.organizationName2.toLowerCase().includes(term))
      );
    });
  }, [data, searchTerm]);

 

  if (isLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>{t('Loading')}</span>
        </div>
        <p className='text-muted mt-2'>{t('LoadingSalesInvoices')}</p>
      </div>
    );
  }

  return (
    <Card className='mb-4'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h6 className='mb-0'>
          <i className='fas fa-file-invoice me-2'></i>
          {t('SalesInvoicesListTitle')}
        </h6>
      </div>

      {/* شريط البحث */}
      <div className='card-body border-bottom'>
        <div className='row g-2 align-items-center'>
          <div className='col-md-8'>
            <div className='input-group'>
              <span className='input-group-text'>
                <i className='fas fa-search'></i>
              </span>
              <input
                type='text'
                className='form-control form-control-sm'
                placeholder={'ابحث برقم الأمر العميل، أو الوحدة التشغيلية...'}
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className='btn btn-outline-secondary btn-sm'
                  type='button'
                  onClick={() => setSearchTerm('')}
                  title={t('ClearSearch') || 'مسح البحث'}
                >
                  <i className='fas fa-times'></i>
                </button>
              )}
            </div>
          </div>

          <div className='col-md-4 text-end'>
            {/* <small className='text-muted'>
              {t('SalesInvoicesFilteredCount') || `عرض ${filteredData.length} من ${data.length}`}
            </small> */}
            {searchTerm && (
              <div className='mt-1'>
                <small className='text-primary'>
                  <i className='fas fa-filter me-1'></i>
                  {t('SearchTermLabel') || 'بحث عن:'} "<strong>{searchTerm}</strong>"
                </small>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* الجدول */}
      <div className='card-body p-0'>
        <div className='table-responsive' style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <table className='table table-hover mb-0'>
            <thead
              className='fw-bold bg-theme bg-opacity-25'
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                 backdropFilter: 'blur(10px)'
              }}
            >
              <tr>
                <th className='text-center small' style={{ width: '50px' }}>
                  #
                </th>
                <th className='text-center small' style={{ width: '15%' }}>
                  {t('InvoiceNumber') || 'رقم الفاتورة'}
                </th>
                <th className='text-center small' style={{ width: '15%' }}>
                  {t('InvoiceDate') || 'تاريخ الفاتورة'}
                </th>
                <th className='text-center small' style={{ width: '20%' }}>
                  {t('Customer') || 'العميل'}
                </th>
                <th className='text-center small' style={{ width: '15%' }}>
                  {t('Amount') || 'المبلغ'}
                </th>
                <th className='text-center small' style={{ width: '20%' }}>
                  {t('OperatingUnit') || 'الوحدة التشغيلية'}
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => {
                  const isSelected = selectedId === item.id;

                  return (
                    <tr
                      key={item.id}
                      className={isSelected ? 'table-primary' : ''}
                      style={{ cursor: 'pointer' }}
                      onClick={() => onSelect(item.id, item.code)}
                    >
                      <td className='text-center align-middle'>
                        <div className='form-check'>
                          <input
                            type='radio'
                            className='form-check-input'
                            name='salesInvoiceSelection'
                            checked={isSelected}
                            onChange={() => onSelect(item.id, item.code)}
                          />
                        </div>
                      </td>

                      <td className='text-center align-middle fw-bold'>
                        {item.code}
                        {searchTerm && item.code && item.code.toLowerCase().includes(searchTerm.toLowerCase()) && (
                          <span className='badge bg-info ms-1' title={t('MatchesSearch') || 'مطابق للبحث'}>
                            <i className='fas fa-check-circle me-1'></i>
                          </span>
                        )}
                      </td>

                      <td className='text-center align-middle'>
                        {item.transactionDate ? item.transactionDate.split('T')[0] : '-'}
                      </td>

                      <td className='text-center align-middle'>
                        {isArabic ? item.peopleName2 || item.peopleName : item.peopleName || item.peopleName2}
                        {searchTerm &&
                          (item.peopleName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            item.peopleName2?.toLowerCase().includes(searchTerm.toLowerCase())) && (
                            <span className='badge bg-info ms-1' title={t('MatchesSearch') || 'مطابق للبحث'}>
                              <i className='fas fa-check-circle me-1'></i>
                            </span>
                          )}
                      </td>

                      <td className='text-center align-middle'>
                        <span className='fw-bold text-primary'>{item.netAmount || item.netSale || 0}</span>
                      </td>

                      <td className='text-center align-middle'>
                        {isArabic
                          ? item.organizationName2 || item.organizationName
                          : item.organizationName || item.organizationName2}
                        {searchTerm &&
                          (item.organizationName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            item.organizationName2?.toLowerCase().includes(searchTerm.toLowerCase())) && (
                            <span className='badge bg-info ms-1' title={t('MatchesSearch') || 'مطابق للبحث'}>
                              <i className='fas fa-check-circle me-1'></i>
                            </span>
                          )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={6} className='text-center py-4'>
                    <div className='text-muted'>
                      <i className='fas fa-search fa-2x mb-3'></i>
                      <h6 className='mb-2'>{t('NoSearchResultsTitle') || 'لا توجد نتائج'}</h6>
                      <p className='mb-0'>
                        {'لا توجد فواتير مطابقة للبحث'} {searchTerm && <>"{searchTerm}"</>}
                      </p>
                      {searchTerm && (
                        <button className='btn btn-sm btn-outline-secondary mt-2' onClick={() => setSearchTerm('')}>
                          <i className='fas fa-times me-1'></i>
                          {t('ClearSearchAndShowAll') || 'مسح البحث وعرض الكل'}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card-footer d-flex justify-content-between align-items-center'>
        <div className='text-muted small'>
          {  `${filteredData.length} أمر بيع  (${data.length} إجمالي)`}
        </div>
      </div>
    </Card>
  );
};
